import * as React from 'react';

import { StatusIcon } from 'components/common';
import type { ReportStatus } from 'report/types';
import Spinner from 'components/common/Spinner';

type Props = {
  value: boolean;
  status: ReportStatus;
};

const PENDING_STATUSSES: ReportStatus[] = ['STARTING', 'RUNNING', 'RETRYING'];
const HasAsset = ({ value, status }: Props) =>
  !value && PENDING_STATUSSES.includes(status) ? <Spinner delay={0} text="" /> : <StatusIcon active={value} />;

export default HasAsset;
